import { BiQueryResult } from '@euler/model/bi/result';
import { BiVizSpec } from '@euler/model/bi/viz';
import { ReactNode, useState } from 'react';
import { BiViewToggle } from '../view-toggle/BiViewToggle';
import { BiViewMode, biHasTableToggle } from './biViewMode';
import { biVizIcon } from './biVizIcon';

/**
 * A card's chart / table view state and its toggle: the toggle only for a
 * chart with rows, and the view shown falls back to the chart for anything
 * else (a card edited into a KPI keeps no stale table view).
 */
export function useBiViewMode(
  /** Null while the card has nothing to show. */
  viz: BiVizSpec | null,
  result: BiQueryResult | null,
): { view: BiViewMode; toggle: ReactNode } {
  const [view, setView] = useState(BiViewMode.Chart);
  const toggleable = !!viz && biHasTableToggle(viz) && !!result?.rows.length;
  return {
    view: toggleable ? view : BiViewMode.Chart,
    toggle: toggleable ? (
      <BiViewToggle
        chartIcon={biVizIcon(viz.type)}
        value={view}
        onChange={setView}
      />
    ) : null,
  };
}
